import React, {useEffect} from 'react';
import Chart from 'chart.js';
import {teamSocialReport} from "../../api/app";
import formatNumber from "../../utils/formatNumber";
const $ = window.$;

const PieChart = (props) => {

    useEffect(() => {
        // Chart.register(DoughnutController, ArcElement, Title, Tooltip);
        teamSocialReport(props.id).then((response) => {
            console.log(response.payload);

            $("#total-fb").text(formatNumber(response.payload.total_facebook));
            $("#total-x").text(formatNumber(response.payload.total_twitter));
            $("#total-tk").text(formatNumber(response.payload.total_tiktok));
            $("#total-rd").text(formatNumber(response.payload.total_radio));

            var datapie = {
                labels: ['Facebook', 'Twitter', 'TiKtok', 'Radio'],
                datasets: [{
                    data: [
                        response.payload.total_facebook,
                        response.payload.total_twitter,
                        response.payload.total_tiktok,
                        response.payload.total_radio],
                    backgroundColor: ['#1877F2', '#000000','#25F4EE','#fdbd88']
                }]
            };

            var optionpie = {
                maintainAspectRatio: false,
                responsive: true,
                legend: {
                    display: false,
                },
                animation: {
                    animateScale: true,
                    animateRotate: true
                }
            };

            var ctx2 = document.getElementById('chartDonut');
            new Chart(ctx2, {
                type: 'doughnut',
                data: datapie,
                options: optionpie
            });
        });
    }, []);

    return (
        <div className="chart-seven">
            <canvas id="chartDonut"></canvas>
            <div className="row mt-5">
                <div className="col-6">
                    <p className="tx-10 tx-uppercase tx-medium tx-color-03 tx-spacing-1 tx-nowrap mg-b-5">Twitter X</p>
                    <div className="d-flex align-items-center">
                        <div className="wd-10 ht-10 rounded-circle bg-brand-01 mg-r-5"></div>
                        <h6 className="tx-normal tx-rubik mg-b-0" id="total-x">0</h6>
                    </div>
                </div>
                <div className="col-6">
                    <p className="tx-10 tx-uppercase tx-medium tx-color-03 tx-spacing-1 mg-b-5">Facebook</p>
                    <div className="d-flex align-items-center">
                        <div className="wd-10 ht-10 rounded-circle bg-primary mg-r-5"></div>
                        <h6 className="tx-normal tx-rubik mg-b-0" id="total-fb">0</h6>
                    </div>
                </div>
                <div className="col-6 mg-t-20">
                    <p className="tx-10 tx-uppercase tx-medium tx-color-03 tx-spacing-1 mg-b-5">Tik Tok</p>
                    <div className="d-flex align-items-center">
                        <div className="wd-10 ht-10 rounded-circle bg-black-9 mg-r-5"></div>
                        <h6 className="tx-normal tx-rubik mg-b-0" id="total-tk">0</h6>
                    </div>
                </div>
                <div className="col-6 mg-t-20">
                    <p className="tx-10 tx-uppercase tx-medium tx-color-03 tx-spacing-1 mg-b-5">Radio</p>
                    <div className="d-flex align-items-center">
                        <div className="wd-10 ht-10 rounded-circle bg-orange mg-r-5"></div>
                        <h6 className="tx-normal tx-rubik mg-b-0" id="total-rd">0</h6>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PieChart;
